module.exports = __webpack_public_path__ + "img/carousel-2.f0177fcc.jpg";